module.exports = __webpack_public_path__ + "media/27.2a3bdfe9.mp3";